import { SITE_URL, geoMeta, businessNode, webPageNode, websiteNode, breadcrumbNode, faqNode, serviceNode, articleNode } from "./config";
import { cityFaqs, cityIntro } from "./cityContent";
import { villesSEO } from "../villes";
import { articles } from "../articles";
import { servicesSeo } from "../servicesSeo";
import { faq as homeFaqs } from "../mock";

export { SITE_URL };

const HOME = { name: "Accueil", path: "/" };

function graph(r, extra = []) {
  const nodes = [businessNode(villesSEO), webPageNode(r.path, r.title, r.description)];
  if (r.path !== "/") nodes.push(breadcrumbNode([HOME, ...r.crumbs]));
  if (r.faqs && r.faqs.length) nodes.push(faqNode(r.faqs));
  return { "@context": "https://schema.org", "@graph": [...nodes, ...extra] };
}

const staticPages = [
  {
    path: "/", priority: "1.0", changefreq: "weekly",
    title: "Marabout Orléans (45) | Sorcier Puissant, Voyant – Maître Diamma",
    description: "Maître Diamma, grand marabout africain et sorcier puissant à Orléans : retour affectif, désenvoûtement, magie blanche, voyance. Orléans, Loiret et environs. Tél 07 45 44 96 41.",
    h1: "Maître Diamma — Marabout & Sorcier puissant à Orléans",
    intro: "Grand marabout, voyant médium et guérisseur africain au centre d'Orléans : retour de l'être aimé, désenvoûtement, anti-sorcellerie, magie blanche et voyance à Orléans, dans la métropole, le Loiret et les villes voisines.",
    faqs: homeFaqs, crumbs: []
  },
  {
    path: "/retour-affectif", priority: "0.9", changefreq: "weekly",
    title: "Retour Affectif Orléans (45) | Faire Revenir l'Être Aimé – Maître Diamma",
    description: "Retour affectif rapide à Orléans : Maître Diamma, marabout africain, ramène l'être aimé et scelle votre couple. Orléans, Olivet, Fleury, Saran, Loiret. 07 45 44 96 41.",
    h1: "Retour affectif à Orléans : ramener l'être aimé",
    intro: "Rupture, silence, infidélité : le retour affectif est la spécialité la plus demandée de Maître Diamma à Orléans et dans tout le Loiret.",
    crumbs: [{ name: "Retour affectif", path: "/retour-affectif" }]
  },
  {
    path: "/voyance", priority: "0.9", changefreq: "weekly",
    title: "Voyant Médium Orléans (45) | Voyance Sérieuse – Maître Diamma",
    description: "Voyance précise à Orléans avec Maître Diamma, voyant médium africain : amour, travail, argent, santé. En cabinet rue de Bourgogne, par téléphone ou WhatsApp, 7j/7.",
    h1: "Voyant médium à Orléans : voir clair, décider juste",
    intro: "Consultation de voyance par oracles africains au centre d'Orléans, dans tout le Loiret ou à distance par téléphone.",
    crumbs: [{ name: "Voyance", path: "/voyance" }]
  },
  {
    path: "/guerisseur", priority: "0.9", changefreq: "weekly",
    title: "Guérisseur Africain Orléans (45) | Soins Traditionnels – Maître Diamma",
    description: "Guérisseur africain à Orléans : soins traditionnels, désenvoûtement, angoisses, insomnies, blocages. Maître Diamma consulte à Orléans, dans la métropole et le Loiret.",
    h1: "Guérisseur africain à Orléans",
    intro: "Soins traditionnels africains pour libérer le corps et l'esprit des blocages, du mal-être et des influences négatives.",
    crumbs: [{ name: "Guérisseur", path: "/guerisseur" }]
  },
  {
    path: "/contact", priority: "0.8", changefreq: "monthly",
    title: "Contact Marabout Orléans | Maître Diamma – 07 45 44 96 41",
    description: "Contactez Maître Diamma, marabout et sorcier puissant au centre d'Orléans : téléphone, WhatsApp 7j/7 de 8h à 22h. Premier contact gratuit et confidentiel.",
    h1: "Contacter Maître Diamma",
    intro: "Appel ou WhatsApp au 07 45 44 96 41, 7j/7 de 8h à 22h. Cabinet au 12 Rue de Bourgogne, 45000 Orléans.",
    crumbs: [{ name: "Contact", path: "/contact" }]
  },
  {
    path: "/blog", priority: "0.8", changefreq: "weekly",
    title: "Marabout à Orléans, dans le Loiret et Alentours | Maître Diamma",
    description: "Trouvez un marabout près de chez vous : Orléans, Olivet, Fleury-les-Aubrais, Saran, Montargis, Gien, Blois, Tours, Chartres… Maître Diamma intervient dans tout le Loiret.",
    h1: "Marabout à Orléans, dans le Loiret et les villes voisines",
    intro: "Orléans Métropole, Loiret et villes voisines : Maître Diamma intervient près de chez vous.",
    crumbs: [{ name: "Villes desservies", path: "/blog" }]
  },
  {
    path: "/articles", priority: "0.8", changefreq: "weekly",
    title: "Blog Marabout Orléans | Sorcellerie, Retour Affectif, Voyance",
    description: "Conseils de Maître Diamma, marabout à Orléans : sorcellerie, signes d'envoûtement, retour affectif, magie blanche, protection et voyance dans le Loiret.",
    h1: "Le blog de Maître Diamma",
    intro: "Guides et conseils sur la sorcellerie, le désenvoûtement, le retour affectif et la voyance à Orléans.",
    crumbs: [{ name: "Articles", path: "/articles" }]
  },
  {
    path: "/mentions-legales", priority: "0.3", changefreq: "yearly",
    title: "Mentions légales | Maître Diamma – Marabout Orléans",
    description: "Mentions légales du site de Maître Diamma, marabout voyant à Orléans (45000).",
    h1: "Mentions légales", intro: "", crumbs: [{ name: "Mentions légales", path: "/mentions-legales" }]
  }
];

const servicePages = servicesSeo.map((s) => ({
  path: `/${s.slug}`, priority: "0.9", changefreq: "weekly",
  title: s.title, description: s.description, h1: s.h1, intro: s.intro,
  sections: s.sections.map((x) => ({ h2: x.h2, p: [x.p] })), faqs: s.faqs,
  crumbs: [{ name: s.h1, path: `/${s.slug}` }],
  extra: [serviceNode(`/${s.slug}`, s.h1, "Orléans")]
}));

const cityPages = villesSEO.map((v) => ({
  path: `/marabout/${v.slug}`, priority: ["orleans", "olivet", "fleury-les-aubrais", "saran", "saint-jean-de-braye", "montargis"].includes(v.slug) ? "0.9" : "0.8", changefreq: "weekly",
  geo: geoMeta(v),
  title: `Marabout ${v.nom} (${v.cp}) | Sorcier Puissant & Voyant – Maître Diamma`,
  description: `Marabout et sorcier puissant à ${v.nom} (${v.cp}) : retour affectif, désenvoûtement, magie blanche, voyance. Maître Diamma, 1er contact gratuit 7j/7 : 07 45 44 96 41.`,
  h1: `Marabout & sorcier puissant à ${v.nom}`,
  intro: cityIntro(v),
  sections: [{ h2: `Quartiers desservis à ${v.nom}`, p: [`${v.quartiers.join(", ")} et tout le secteur.`] }],
  faqs: cityFaqs(v),
  crumbs: [{ name: "Villes desservies", path: "/blog" }, { name: `Marabout ${v.nom}`, path: `/marabout/${v.slug}` }],
  extra: [
    serviceNode(`/marabout/${v.slug}`, `Marabout à ${v.nom}`, v.nom, v),
    serviceNode(`/marabout/${v.slug}`, `Sorcier puissant à ${v.nom}`, v.nom, v)
  ]
}));

const articlePages = articles.map((a) => ({
  path: `/articles/${a.slug}`, priority: "0.7", changefreq: "monthly", lastmod: a.date,
  title: `${a.title} | Maître Diamma`, description: a.description, h1: a.title, intro: a.description,
  sections: a.sections,
  crumbs: [{ name: "Articles", path: "/articles" }, { name: a.title, path: `/articles/${a.slug}` }],
  extra: [articleNode(`/articles/${a.slug}`, a)]
}));

export const routesMeta = [...staticPages, ...servicePages, ...cityPages, ...articlePages].map((r) => ({
  ...r,
  geo: r.geo || geoMeta(),
  jsonLd: graph(r, r.path === "/" ? [websiteNode()] : r.extra || [])
}));

export function findRouteMeta(pathname) {
  const p = pathname.length > 1 ? pathname.replace(/\/+$/, "") : pathname;
  return routesMeta.find((r) => r.path === p);
}
